module.exports = __webpack_public_path__ + "static/img/p_18.25129d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/p_18.jpg
// module id = e+Dg
// module chunks = 9